import { Icons } from "./icons";
import { InfiniteScroll } from "./infiniteScroll";
import { PushPrompt } from "./PushPrompt";
import { PushToggle } from "./PushToggle";
import { RightSidebarTabs } from "./RightSidebarTabs";
import { Sidebar } from "./Sidebar";
import { SidebarNav } from "./SidebarNav";
import { ScrollRestore } from "./scrollRestore";
import { Toast } from "./toast";
// import { ConfirmDialog } from "./ConfirmDialog";

export class UI {
  static compiler() {
    Toast.compiler();
    // ConfirmDialog.init()
    // ScrollRestore 必须在 InfiniteScroll 之前注册，
    // 这样恢复快照后 up.hello() 触发的 sentinel 编译才能正确绑定
    ScrollRestore.compiler("[data-scroll-restore]");
    InfiniteScroll.compiler(".infinite-sentinel");
    SidebarNav.compiler();
    Sidebar.compiler();
    RightSidebarTabs.compiler();
    Icons.compiler();
    PushPrompt.compiler();
    PushToggle.compiler();
  }
}
